import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  Button,
  Select,
  Table,
  Col,
  Row,
  DatePicker,
  Modal,
  Input,
  Divider,
  Space,
  Popconfirm,
  Checkbox,
  message,
  Image,
  Upload,
  Tooltip,
} from "antd";
import {
  DeleteOutlined,
  CameraOutlined,
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons";
import server, { endpoints } from "../utils/server";
import moment from "moment";
import AddUser from "../components/addUserWorkshops";
import "./styles/workshops.css";
import { useHistory } from "react-router-dom";


const { Option } = Select;
const Workshops = ({ idCycle }) => {
  useEffect(() => {
    setAssistanceListNumber();
    getWorkshopOfOtherCycle();
    getWorkshopInCycle();
  }, []);

  const [assistanceArray, setAssistanceArray] = useState([]); // Variable para poder desplegar los asistentes en el modal de asistentes, se sirve del llamado a back getAttendance
  const [selectedIdSession, setSelectedIdSession] = useState(0); //Variable para proporcionar la sesion que se esta editando en donde se necesite
  const [lastIdSession, setLastIdSession] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [assistanceList, setAssistanceList] = useState(0);
  const [workshopName, setWorkshopName] = useState("");
  const [newWorkshopNameToInsert, setnewWorkshopNameToInsert] = useState();
  const [selectedDate, setSelectedDate] = useState(""); //Variable para poner la fecha seleccionada por el usuario al crear una nueva clase
  const [newClassName, setNewClassName] = useState(""); //Variable para el nombre de una clase nueva
  const [workshopId, setWorkshopId] = useState(0); // Variable para proporcionar a los llamados de back con el Id de el taller seleccionado por el usuario
  const [participantArray, setParticipantArray] = useState([]); //Variable para poder desplegar los participantes en el modal de participantes, se sirve del llamado a back getUserInWorkshopPerCycle
  const [isClassesModalOpen, setIsClassesModalOpen] = useState(false); //setStates para abrir los modales. ClassesModal.- Nueva clase / AssistanceModal.- Asistencia / WorkshopsModal.- Nuevo taller / ParticipantModal .- Participantes
  const [isAssistanceModalOpen, setIsAssistanceModalOpen] = useState(false);
  const [isWorkshopsModalOpen, setIsWorkshopsModalOpen] = useState(false);
  const [isParticipantsModalOpen, setIsParticipantsModalOpen] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false); //Variable para desabilitar botones de agregar clase y participantes en caso de no haberse seleccionado un taller
  const [button, setButton] = useState(false);
  const [newWorkshopName, setNewWorkshopName] = useState(""); //Variable usada para añadir un nuevo taller. Se usa en el modal3
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedNewWorkshopInCycle, setselectedNewWorkshopInCycle] =
    useState();
  const [temporaryArray, setTemporaryArray] = useState([]);
  const [newarray, setNewArray] = useState([]);
  const [userInsert, setUserInsert] = useState([]);
  const [selectNewWorkshopVisible, setselectNewWorkshopVisible] =
    useState(false);

  //EndPoint//

  const getWorkshopSessions = async (workshopId) => {
    try {
      const { data: reversedSessions } = await server(
        endpoints.getWorkshopSessions.route,
        endpoints.getWorkshopSessions.method,
        { id_workshop: workshopId, id_cycle: idCycle }
      );
      setLastIdSession(reversedSessions[0]?.id);
      setSelectedValue(reversedSessions.reverse());
    } catch (error) {
      message.error(error);
    }
  };

  const getUserInWorkshopPerCycle = async () => {
    const res = await server(
      endpoints.getUserInWorkshopPerCycle.route,
      endpoints.getUserInWorkshopPerCycle.method,
      { id_cycle: idCycle, id_workshop: workshopId }
    );
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setParticipantArray(res.data);
    }
  };

  const getAttendance = async (idSession) => {
    const res = await server(
      endpoints.getAttendance.route,
      endpoints.getAttendance.method,
      { id_session: idSession }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      setAssistanceArray(res.data.attendance);
    }
  };

  const updateAttendance = async () => {
    const body = assistanceArray.map((e) => ({
      id_attendance: e.id_attendance || 0,
      id_user: e.id_user,
      attendance: e.attendance || 0,
    }));
    const res = await server(
      endpoints.updateAttendance.route,
      endpoints.updateAttendance.method,
      { id_session: selectedIdSession },
      { attendance: body }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      message.success(res.message);
      getWorkshopSessions(workshopId);
      setIsAssistanceModalOpen(false);
      setButton(false);
    }
  };

  const updateAttendanceForBug = async () => {
    const body = assistanceArray.map((e) => ({
      id_attendance: e.id_attendance || 0,
      id_user: e.id_user,
      attendance: e.attendance || 0,
    }));
    const res = await server(
      endpoints.updateAttendance.route,
      endpoints.updateAttendance.method,
      { id_session: lastIdSession },
      { attendance: body }
    );
    getWorkshopSessions(workshopId);
  };

  const insertWorkshopsSessions = async () => {
    const res = await server(
      endpoints.insertWorkshopsSessions.route,
      endpoints.insertWorkshopsSessions.method,
      { id_workshop: workshopId, id_cycle: idCycle },
      {
        name: newClassName,
        start_date: selectedDate,
      }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      message.success(res.message);
      getWorkshopSessions(workshopId);
      setIsClassesModalOpen(false);
      setNewClassName("");
      setSelectedDate("");
    }
  };

  const deleteWorkshopSessions = async (selectedIdSession) => {
    const res = await server(
      endpoints.deleteWorkshopSessions.route,
      endpoints.deleteWorkshopSessions.method,
      { id_workshop_session: selectedIdSession }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      message.success(res.message);
      getWorkshopSessions(workshopId);
    }
  };

  const history = useHistory();

  const getWorkshopOfOtherCycle = async () => {
    try {
      const res = await server(
        endpoints.getWorkshopOfOtherCycle.route,
        endpoints.getWorkshopOfOtherCycle.method,
        { id_cycle: idCycle }
      );

      if (res.error_message) {
        message.error(res.error_message);
        if (res.error_message === "Por favor actualice su contraseña") {
          history.push("/changePassword");
        }
        return;
      }

      setworkshopsOtherCycles(res.data.workshopsOfOtherCycles);
    } catch (error) {
      console.error("Error al obtener los talleres de otros ciclos:", error);
    }
  };

  const deleteWorkshopInCycle = async () => {
    const res = await server(
      endpoints.deleteWorkshopInCycle.route,
      endpoints.deleteWorkshopInCycle.method,
      { id_cycle: idCycle, id_workshop: selectedNewWorkshopInCycle }
    );

    if (res.error_message.length !== 0) {
      message.error(res.message_error);
    } else {
      message.success(res.message);
    }
    getWorkshopInCycle();
    setWorkshopName();
    setselectedNewWorkshopInCycle();
    setSelectedValue();
    setDisableButtons(false);
  };

  const putSessionPhoto = async (id, fileContents, fileName) => {
    const res = await server(
      endpoints.putSessionPhoto.route,
      endpoints.putSessionPhoto.method,
      { id_session: id },
      { fileContents, fileName }
    );
    if (res.error_message) {
      message.error(res.message_error);
    } else {
      message.success(res.message);
      getWorkshopSessions(workshopId);
    }
  };

  //Handlers

  const handleOnAssistanceChange = (id) => {
    let auxArray = [...assistanceArray];
    const index = auxArray.map((e) => e.id_user).indexOf(id);
    if (auxArray[index].attendance === 1) {
      auxArray[index].attendance = 0;
      setButton(true);
    } else if (auxArray[index].attendance === 0) {
      auxArray[index].attendance = 1;
      setButton(true);
    }

    setAssistanceArray(auxArray);
    setAssistanceListNumber();
  };

  const handleSelectOnChange = (value, m) => {
    setselectedNewWorkshopInCycle(m.key);
    setWorkshopName(m.value);
    if (value !== "") {
      setDisableButtons(true); //Si un taller es seleccionado, y el valor que se manda desde el select (value) es diferente a "", entonces se pueden habilitar los botones para usarse
      setWorkshopId(m.key);
    }
    getWorkshopSessions(m.key);
  };
  const handleSelectOnChangeWorkshopToInsert = (value, m) => {
    setselectedNewWorkshopInCycle(m.key);
    setnewWorkshopNameToInsert(m.value);
    if (value !== "") {
      setDisableButtons(true); //Si un taller es seleccionado, y el valor que se manda desde el select (value) es diferente a "", entonces se pueden abilitar los botones para usarse
    }
  };

  const handleDatePickerOnChange = (e) => {
    setSelectedDate(e ? e.valueOf().toString() : "");
  };

  const handleClassNameOnChange = (e) => {
    setNewClassName(e.target.value);
  };

  //Setters

  const setAssistanceListNumber = () => {
    //Función que checa cuantos de los estudiantes estan presentes, pero solo para desplegar en la tabla
    var count = 0;
    for (let i = 0; i < assistanceArray.length; i++) {
      if (assistanceArray[i].attendance === true) {
        count++;
      }
    }
    setAssistanceList(count);
  };

  const defaultColumns = [
    {
      title: "Foto de sesión",
      dataIndex: "session_photo",
      key: "session_photo",
      align: "center",
      render: (key, element) => (
        <>
          {key ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <Image width={70} src={key} fallback={imgFallback} />
                <form>
                  <Upload
                    accept="image/*"
                    multiple={false}
                    beforeUpload={(e) => beforeUpload(e, element.id)}
                    showUploadList={false}
                  >
                    <Tooltip title="Editar imagen de sesión">
                      <Button
                        shape="circle"
                        icon={<EditOutlined />}
                        type="primary"
                        size="small"
                        style={{
                          backgroundColor: "#808080",
                          borderColor: "#808080",
                        }}
                      />
                    </Tooltip>
                  </Upload>
                </form>
              </div>
            </>
          ) : (
            <form>
              <Upload
                accept="image/*"
                multiple={false}
                beforeUpload={(e) => beforeUpload(e, element.id)}
                showUploadList={false}
              >
                <Tooltip title="Agregar imagen de sesión">
                  <Button
                    shape="circle"
                    icon={<CameraOutlined />}
                    type="primary"
                    style={{
                      backgroundColor: "#808080",
                      borderColor: "#808080",
                      marginLeft: "0.8rem",
                    }}
                  />
                </Tooltip>
              </Upload>
            </form>
          )}
        </>
      ),
    },
    {
      title: "Clase",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Fecha",
      dataIndex: "start_date",
      key: "date",
      align: "center",
      render: (date, class_info) => (
        <DatePicker
          showToday="true"
          showTime={{ format: "HH:mm" }}
          format="YYYY-MM-DD HH:mm"
          value={moment(class_info.start_date)}
        ></DatePicker>
      ),
    },
    {
      title: "Asistencias",
      dataIndex: "attendees",
      key: "attendees",
      align: "center",
      render: (attendees, element) => (
        <>
          <Button
            type="default"
            size="small"
            style={{ marginRight: "1rem", borderRadius: "15px" }}
            onClick={() => {
              setSelectedIdSession(element.id);
              getAttendance(element.id);

              setPaginationAssistanceList({
                ...paginationAssistanceList,
                currentPage: 1,
              });
              showAssistanceModal();
            }}
          >
            Lista de asistencia
          </Button>

          {`${attendees}/${element.totalUsersInSession}`}
        </>
      ),
    },
    {
      title: "Acciones",
      dataIndex: "id",
      key: "id",
      align: "center",
      render: (key) => showDeleteConfirm(key),
    },
  ];

  const encodeFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
        if (encoded.length % 4 > 0) {
          encoded += "=".repeat(4 - (encoded.length % 4));
        }
        resolve(encoded);
      };
      reader.onerror = (error) => reject(error);
    });

  const beforeUpload = async (file, id) => {
    let converted_file = await encodeFile(file);
    putSessionPhoto(id, converted_file, file.name);
  };

  const [paginationAssistanceList, setPaginationAssistanceList] = useState({
    pages: Math.ceil(assistanceArray.length / 10) + 1,
    itemCount: 10,
    currentPage: 1, //Define el numero de paginas maximo (5), limite de items por pagina (16), y la pagina en la que empieza al abrir la app (1) en la paginacion del AssistanceModal
  });

  const paginationArrayAssistanceList = () => {
    setTemporaryArray([]);
    const array_extra = [];
    const item_start =
      (paginationAssistanceList.currentPage - 1) *
      paginationAssistanceList.itemCount;
    const item_show =
      paginationAssistanceList.currentPage * paginationAssistanceList.itemCount;

    assistanceArray.map((i, index) => {
      if (index >= item_start && index < item_show) {
        array_extra.push(i);
      }
    });
    setTemporaryArray(array_extra);
  };

  useEffect(() => {
    paginationArrayAssistanceList();
  }, [assistanceArray, paginationAssistanceList]);

  useEffect(() => {
    setPaginationAssistanceList({
      ...paginationAssistanceList,
      pages: Math.ceil(assistanceArray.length / 10),
    });
  }, [assistanceArray]);

  const toNextPageAssistanceList = () => {
    if (
      assistanceArray.length >
      paginationAssistanceList.itemCount * paginationAssistanceList.pages
    )
      paginationAssistanceList.pages++;

    const nextPage = Math.min(
      paginationAssistanceList.currentPage + 1,
      paginationAssistanceList.pages
    );
    setPaginationAssistanceList({
      ...paginationAssistanceList,
      currentPage: nextPage,
    });
  };

  const toPrevPageAssistanceList = () => {
    const prevPage = Math.max(paginationAssistanceList.currentPage - 1, 1);

    setPaginationAssistanceList({
      ...paginationAssistanceList,
      currentPage: prevPage,
    });
  };

  const [paginationParticipants, setPaginationParticipants] = useState({
    pages: Math.ceil(participantArray.length / 9),
    itemCount: 9,
    currentPage: 1,
  });

  const toNextPageParticipants = () => {
    if (
      participantArray.length >
      paginationParticipants.itemCount * paginationParticipants.pages
    )
      paginationParticipants.pages++;
    const nextPage = Math.min(
      paginationParticipants.currentPage + 1,
      paginationParticipants.pages
    );
    setPaginationParticipants({
      ...paginationParticipants,
      currentPage: nextPage,
    });
  };
  const toPrevPageParticipants = () => {
    const prevPage = Math.max(paginationParticipants.currentPage - 1, 1);
    setPaginationParticipants({
      ...paginationParticipants,
      currentPage: prevPage,
    });
  };

  const paginationParticipantschange = () => {
    setNewArray([]);
    const array_temporal = [];
    const item_start =
      (paginationParticipants.currentPage - 1) *
      paginationParticipants.itemCount;
    const item_show =
      paginationParticipants.currentPage * paginationParticipants.itemCount;

    participantArray.map((i, index) => {
      if (index >= item_start && index < item_show) array_temporal.push(i);
    });

    setNewArray(array_temporal);
  };

  // UseEffect para recargar la lista de participants
  useEffect(() => {
    paginationParticipantschange();
  }, [participantArray, paginationParticipants]);

  const deleteUserInWorkshopPerCycle = async (idUser) => {
    const res = await server(
      endpoints.deleteUserInWorkshopPerCycle.route,
      endpoints.deleteUserInWorkshopPerCycle.method,
      { id_user: idUser, id_workshop: workshopId, id_cycle: idCycle }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      message.success(res.message);
      getUserInWorkshopPerCycle();
      getUsersOfOtherWorkshopPerCycle();
    }
  };

  const getUsersOfOtherWorkshopPerCycle = async () => {
    const res = await server(
      endpoints.getUsersOfOtherWorkshopPerCycle.route,
      endpoints.getUsersOfOtherWorkshopPerCycle.method,
      { id_cycle: idCycle, id_workshop: selectedNewWorkshopInCycle }
    );
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setUserInsert(res.data.usersOfOtherWorkshopPerCycle);
    }
  };

  //Funcion para preguntar si el usuario si desea borrar la fila de la tabla. Se llama a handleDeleteConfirm para borrarla
  const showDeleteConfirm = (key) => {
    return (
      <Popconfirm
        title="¿Segur@ que quieres eliminar esta clase?"
        okText="Si"
        okType="danger"
        cancelText="Cancelar"
        onConfirm={() => {
          deleteWorkshopSessions(key);
        }}
      >
        <DeleteOutlined />
      </Popconfirm>
    );
  };

  const imgFallback =
    "data:image/png;base64,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";

  const tableContainerStyle = {
    width: "90%",
    borderRadius: "15px",
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  };
  const showClassesModal = () => {
    //showModal.- Hace que sea visible el modal especifico / handleOk y handleCancel.- Hace que el modal desaparezca, puesto que el usuario ya termino con el modal
    setIsClassesModalOpen(true);
  };
  const handleClassesModalCancel = () => {
    setNewClassName("");
    setSelectedDate("");
    setIsClassesModalOpen(false);
  };
  const showAssistanceModal = () => {
    setIsAssistanceModalOpen(true);
  };
  const handleAssistanceModalOk = () => {
    setIsAssistanceModalOpen(false);
  };
  const handleAssistanceModalCancel = () => {
    setIsAssistanceModalOpen(false);
    setButton(false);
  };
  const showWorkshopsModal = () => {
    setIsWorkshopsModalOpen(true);
  };
  const handleWorkshopsModalCancel = () => {
    setIsWorkshopsModalOpen(false);
    setnewWorkshopNameToInsert();
    setNewWorkshopName("");
  };
  const handleParticipantsModalOk = () => {
    setIsParticipantsModalOpen(false);
  };
  const showParticipantsModal = () => {
    setIsParticipantsModalOpen(true);
  };
  const handleParticipantsModalCancel = () => {
    setIsParticipantsModalOpen(false);
  };
  ///////////////////////////////////////////////////////////////////////////////
  //Endpoints de clases

  const [workshopsInCycle, setWorkshopsInCycle] = useState([]);
  const getWorkshopInCycle = async () => {
    const res = await server(
      endpoints.getWorkshopInCycle.route,
      endpoints.getWorkshopInCycle.method,
      { id_cycle: idCycle }
    );
    if (res.error_message) {
      message.error(res.error_message);
      return;
    } else {
      setWorkshopsInCycle(res.data.workshop);
    }
  };

  const insertWorkshopInCycle = async () => {
    const res = await server(
      endpoints.insertWorkshopInCycle.route,
      endpoints.insertWorkshopInCycle.method,
      { id_cycle: idCycle, id_workshop: selectedNewWorkshopInCycle },
      { name: newWorkshopName }
    );
    if (res.error_message.length !== 0) {
      message.error(res.message_error);
    } else {
      message.success(res.message);
    }
    getWorkshopOfOtherCycle();
    getWorkshopInCycle();
    setselectedNewWorkshopInCycle();
    setWorkshopName();
    setnewWorkshopNameToInsert();
    setSelectedValue();
    setDisableButtons(false);
  };

  const dropdownRenderWorkshops = (menus) => (
    <div>
      {menus}
      <Divider style={{ margin: 0 }} />
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Nombre de la nueva clase"
          onChange={(e) => {
            setNewWorkshopName(e.target.value);
            setselectedNewWorkshopInCycle(0);
          }}
          style={{ width: "55%" }}
          value={newWorkshopName}
        />
        <Button
          type="link"
          onClick={() => {
            insertWorkshopInCycle();
            setIsWorkshopsModalOpen(false);
            setselectNewWorkshopVisible(false);
            setNewWorkshopName("");
          }}
        >
          Agregar
        </Button>
      </div>
    </div>
  );

  const dropdownRender = (menus) => (
    <div>
      <div style={{ padding: 8 }}>
        <Button type="link" onClick={showWorkshopsModal}>
          Agregar taller <PlusOutlined />
        </Button>
        {menus}
      </div>
    </div>
  );
  const [workshopsOtherCycles, setworkshopsOtherCycles] = useState([]);

  return (
    <>
      {contextHolder}
      <Col className="workshops">
        <Row
          className="workshops-header"
          justify="space-between"
          align="middle"
        >
          <Row style={{ display: "flex" }}>
            <div className="workshops-select">
              <Space style={{ gap: "30px" }}>
                <h3 style={{ float: "left", fontSize: "16px" }}>Taller: </h3>
                <Select
                  style={{
                    width: "200px",
                    height: "30px",
                    float: "left",
                  }}
                  dropdownRender={dropdownRender}
                  placeholder="Seleccionar"
                  onChange={(e, m) => {
                    handleSelectOnChange(e, m);
                  }}
                  value={workshopName}
                  showSearch
                >
                  {workshopsInCycle.map((t) => {
                    //Mapeo para mostrar las opciones con back en el select de talleres
                    return (
                      <Option key={t.id} value={t.name}>
                        {t.name}
                      </Option>
                    );
                  })}
                </Select>
              </Space>
            </div>

            <h1 style={{ float: "left", marginLeft: "4rem" }}>
              {workshopName}
            </h1>
          </Row>
          <Divider
            style={{
              backgroundColor: "black",
            }}
          />
          <Row className="workshop-actions">
            <Popconfirm
              title="¿Segur@ que quieres eliminar este taller?"
              okText="Si"
              okType="danger"
              cancelText="Cancelar"
              onConfirm={() => {
                if (selectedNewWorkshopInCycle > 0) {
                  deleteWorkshopInCycle();
                } else message.error("Seleccione un taller primero");
              }}
              disabled={!disableButtons}
            >
              <Button
                className="workshop-delete-button"
                danger
                disabled={!disableButtons}
              >
                Eliminar del ciclo
              </Button>
            </Popconfirm>
            <Button
              onClick={() => showClassesModal()}
              type="primary"
              style={{
                borderRadius: "20px",
                height: "50px",
                width: "194px",
                marginRight: "2rem",
                marginLeft: "30%",
                fontSize: "16px",
              }}
              disabled={!disableButtons}
            >
              Agregar Clase
            </Button>
            {/*Modal de clases */}
            <Modal
              title="Agregar Clase"
              visible={isClassesModalOpen}
              onOk={() => {
                insertWorkshopsSessions();
              }} //////////////////////////////////////////////////////
              onCancel={handleClassesModalCancel}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <h3
                    style={{
                      marginLeft: "-17%",
                      marginRight: "4%",
                      marginBottom: "5%",
                      alignItems: "stretch",
                    }}
                  >
                    Clase:{" "}
                  </h3>
                  <Input
                    placeholder="Ej.- Ensayo 01"
                    onChange={handleClassNameOnChange}
                    style={{ width: "100%", marginBottom: "2%" }}
                    value={newClassName}
                  />
                </div>
                <div style={{ display: "flex", marginBottom: "1%" }}>
                  <h3>Fecha de inicio: </h3>
                  <DatePicker
                    style={{ width: "50%" }}
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    onChange={(_, e) => handleDatePickerOnChange(e)}
                    value={selectedDate ? moment(selectedDate) : null}
                  ></DatePicker>
                </div>
              </div>
            </Modal>
            <Button
              className="workshop-participants-button"
              onClick={() => {
                getUserInWorkshopPerCycle();

                showParticipantsModal();
                getUsersOfOtherWorkshopPerCycle();

                paginationAssistanceList.currentPage = 1;
              }}
              disabled={!disableButtons}
            >
              Participantes
            </Button>
            {/*Modal de participantes */}
            <Modal
              title="Participantes"
              visible={isParticipantsModalOpen}
              onOk={() => {
                handleParticipantsModalOk();
                updateAttendanceForBug();
              }}
              onCancel={() => {
                handleParticipantsModalCancel();
              }}
              okText="Aceptar"
              cancelText="Cancelar"
              destroyOnClose={true}
              width={900}
              height={500}
            >
              <Row>
                <Col span={11} align="center" justifycontent="center">
                  <div>
                    {newarray.map((i, index) => {
                      return (
                        <div style={{ width: "70%" }} key={index}>
                          <div style={{ display: "flex" }}>
                            <h3>
                              {index +
                                1 +
                                (paginationParticipants.currentPage - 1) *
                                  paginationParticipants.itemCount}
                              . - {i.first_name} {i.last_name}
                            </h3>
                            <Popconfirm
                              title="Eliminar Participante"
                              description="Seguro que quiere eliminar a este participante?"
                              key={i.id_user}
                              onConfirm={() => {
                                deleteUserInWorkshopPerCycle(i.id_user);
                              }}
                              okText="Si"
                              cancelText="No"
                            >
                              <DeleteOutlined
                                style={{
                                  marginLeft: "auto",
                                }}
                              />
                            </Popconfirm>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "0%",
                      marginLeft: "38%",
                    }}
                  >
                    <button onClick={toPrevPageParticipants}>
                      <LeftOutlined />
                    </button>
                    <span>
                      {paginationParticipants.currentPage} /
                      {Math.ceil(participantArray.length / 9)}
                    </span>
                    <button onClick={toNextPageParticipants}>
                      <RightOutlined />
                    </button>
                  </div>
                </Col>
                <Divider
                  type="vertical"
                  style={{
                    height: "auto",
                  }}
                />
                <Col span={10}>
                  <Row
                    style={{ height: "10%", alignItems: "center" }}
                    align="center"
                  >
                    <div style={{ fontSize: "20px", fontWeight: "600" }}>
                      Total: {participantArray.length}
                    </div>
                  </Row>
                  <Divider />
                  <Row align="center">
                    <h3 align="center">Agregar a un participante</h3>
                    <Divider />
                    <AddUser
                      selectedNewWorkshopInCycle={selectedNewWorkshopInCycle}
                      idCycle={idCycle}
                      usersToInsert={userInsert}
                      onHandleCancel={getUserInWorkshopPerCycle}
                      onHandleAdded={() => {
                        getUsersOfOtherWorkshopPerCycle();
                      }}
                    />
                  </Row>
                </Col>
              </Row>
            </Modal>
          </Row>
        </Row>
        <Row
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "2%",
          }}
        >
          <div style={tableContainerStyle}>
            <Table
              rowClassName={"workshop-table-row"}
              scroll={{ x: 200 }}
              columns={defaultColumns}
              dataSource={selectedValue}
              bordered={true}
              size="middle"
              className="workshop-table"
              style={{ alignItems: "center" }}
            />
          </div>
        </Row>
        {/*Modal de lista de asistencia, se accede desde la tabla */}
        <Modal
          title="Lista de asistencia"
          visible={isAssistanceModalOpen}
          onOk={handleAssistanceModalOk}
          onCancel={handleAssistanceModalCancel}
          footer={null}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="newStyle"
        >
          <div style={{ textAlign: "center", width: "500px", height: "350px" }}>
            {temporaryArray.map((i, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "-25px",
                      marginTop: "-25px",
                      justifyContent: "left",
                      alignItems: "center",
                      width: "80%",
                    }}
                  >
                    <Checkbox
                      checked={i.attendance}
                      onChange={() => {
                        handleOnAssistanceChange(i.id_user);
                        paginationArrayAssistanceList();
                      }}
                      style={{
                        marginLeft: "30%",
                      }}
                    />
                    <h3
                      style={{
                        marginLeft: "20%",
                      }}
                    >
                      {index +
                        1 +
                        (paginationAssistanceList.currentPage - 1) *
                          paginationAssistanceList.itemCount}
                      .- {i.first_name} {i.last_name}
                    </h3>
                  </div>
                  <Divider style={{ size: "100%" }} />
                </div>
              );
            })}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ gridColumn: "2" }}>
              <button onClick={toPrevPageAssistanceList}>
                <LeftOutlined />
              </button>
              <>
                {paginationAssistanceList.currentPage} /{" "}
                {paginationAssistanceList.pages}
              </>
              <button onClick={toNextPageAssistanceList}>
                <RightOutlined />
              </button>
            </div>
            <div style={{ gridColumn: "3" }}>
              <Button
                type="primary"
                disabled={!button}
                onClick={() => {
                  updateAttendance();
                }}
              >
                Actualizar
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title="Agregar Taller al ciclo"
          visible={isWorkshopsModalOpen}
          okText="Agregar"
          cancelText="Cancelar"
          onOk={() => {
            setIsWorkshopsModalOpen(false);
            insertWorkshopInCycle();
            setNewWorkshopName("");
          }} //Ya que se haya actualizado workshopName, se le da al arreglo de options. Value se añade tomando el length del array y sumandole uno para que siempre este correcto (Si length es 3, el nuevo valor será length+1). Tambien cierra el modal, por lo que no tiene un "handleOk3"
          onCancel={handleWorkshopsModalCancel}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col>
              <Row>
                <h3>Taller a agregar </h3>
              </Row>
              <Row>
                <Select
                  open={selectNewWorkshopVisible}
                  style={{
                    width: "200px",
                  }}
                  dropdownRender={dropdownRenderWorkshops}
                  placeholder="Seleccionar"
                  onChange={(e, m) =>
                    handleSelectOnChangeWorkshopToInsert(e, m)
                  }
                  value={newWorkshopNameToInsert}
                  onDropdownVisibleChange={(visible) =>
                    setselectNewWorkshopVisible(visible)
                  }
                  showSearch
                >
                  {workshopsOtherCycles.map((t) => {
                    //Mapeo para mostrar las opciones con back en el select de talleres
                    return (
                      <Option key={t.id} value={t.name}>
                        {t.name}
                      </Option>
                    );
                  })}
                </Select>
              </Row>
            </Col>
          </div>
        </Modal>
      </Col>
    </>
  );
};

export default Workshops;
